import React from 'react'

import { ReactFC } from '../types'
import { AppBottomNavigation } from '../navigation/app-bottom-nav'



export const CircleBottomNavigation: ReactFC<{ fixed: boolean }> = ({ fixed }) => {
    return (
        <AppBottomNavigation fixed={fixed}>
        </AppBottomNavigation>
    )
}
